import api from '@/api'
export const getUserInfo = async (request) => {
  let userInfo = sessionStorage.getItem('userInfo')
  if (userInfo && !request) {
    return JSON.parse(userInfo)
  } else {
    let { data } = await api.organ.getUserInfo()
    sessionStorage.setItem('userInfo', JSON.stringify(data))
    return data
  }
}
export const loginMethod = async () => {
  let userInfo = await getUserInfo()
  // 单点登录时隐藏用户操作按钮 返回false
  // belongSystem   0是单点登录,1是密码登录
  return Boolean(userInfo.belongSystem)
}

// 过滤掉单点登录需要隐藏的权限
export const filterTree = (data) => {
  return data.map((item) => {
    if (item.children) {
      filterTree(item.children)
    }
    // 如果有角色设置,说明该位置就是组织管理权限
    if (item.childrens && item.childrens.find((item) => item.title == '角色设置')) {
      item.childrens = [
        { title: '查看', code: 'userM-look' },
        { title: '角色设置', code: 'userM-role' },
        { title: '编辑用户', code: 'userM-putUser' }
      ]
    }
    return item
  })
}
